import BigNumber from 'bignumber.js';
import { Contract, ethers } from 'ethers';
import { ENVS } from 'src/configs/Configs.env';
import { getContract } from 'src/functions/getContract';
import { Web3Provider } from '@ethersproject/providers';
import contractIDOPoolABI from '../../../contracts/IdoPool.json';
import contractIDODiamondPoolABI from '../../../contracts/idoDiamondPool.json';

export const apiGetPoolApprovedByID = async (poolID: any, poolType?: number, poolStatus?: number) => {
    let apiURL = `${ENVS.REACT_APP_BASE_API}pool-approved/?filter[social_url.in]=${poolID}`;
    if (poolType) {
        apiURL += `&filter[pool_type]=${poolType}`;
    }
    if (poolStatus) {
        apiURL += `&filter[status]=${poolStatus}`;
    }
    const parameters = {
        method: 'GET',
    };
    return fetch(apiURL, parameters)
        .then((response) => {
            return response.json();
        })
        .then((json) => {
            return json;
        });
};

export const apiGetPoolApproved = async (networkFilter: null | string) => {
    let apiURL = `${ENVS.REACT_APP_BASE_API}pool-approved/?filter[listing_status.in]=3,4&filter[pool_type]=1&filter[open_time.sort]=desc&limit=50`;

    if (networkFilter) {
        apiURL += `&filter[network.in]=${networkFilter}`;
    }

    const parameters = {
        method: 'GET',
    };
    return fetch(apiURL, parameters)
        .then((response) => {
            return response.json();
        })
        .then((json) => {
            return json;
        });
};
export const apiCheckIsWhiteList = async (address: any) => {
    const apiURL = `${ENVS.REACT_APP_BASE_API}pool-address-whitelist/${address}`;
    const parameters = {
        method: 'GET',
    };
    return fetch(apiURL, parameters)
        .then((response) => {
            return response.json();
        })
        .then((json) => {
            return json;
        });
};

export const getSwapInfo = async (poolContract: Contract, address?: string) => {
    try {
        let poolInfo: any = [];
        if (address) {
            poolInfo = await poolContract.getPoolInfo();
        } else {
            poolInfo = await poolContract.methods.getPoolInfo().call();
        }
        const hardCap = new BigNumber(poolInfo[0].toString()).div(10 ** 18).toNumber();
        const totalRaise = new BigNumber(poolInfo[6].toString()).div(10 ** 18).toNumber();

        return { hardCap, totalRaise };
    } catch (error) {
        console.log('getSwapInfo: ', error);
        throw error;
    }
};

export const getTokenClaimInfo = async (poolContract: Contract, address: string) => {
    try {
        const accountInfo = await poolContract.getAccountInfo(address);
        const contributions = new BigNumber(accountInfo[0].toString()).div(10 ** 18).toNumber();
        const userTokenBalance = new BigNumber(accountInfo[1].toString()).div(10 ** 18).toNumber();
        const userVestedBalance = new BigNumber(accountInfo[2].toString()).div(10 ** 18).toNumber();
        const lasTimeVesting = accountInfo[3].toNumber();
        return { contributions, userTokenBalance, userVestedBalance, lasTimeVesting };
    } catch (error) {
        console.log('getTokenClaimInfo: ', error);
        throw error;
    }
};

export const getTimePass = async (poolContract: Contract) => {
    try {
        const timePass = await poolContract.timePass();
        return timePass.toNumber();
    } catch (error) {
        console.log('getTimePass: ', error);
        throw error;
    }
};

export const getDiamondHandType = async (poolContract: Contract, address: string) => {
    try {
        const diamondHandType = await poolContract.diamondHandType(address);
        return diamondHandType.toNumber();
    } catch (error) {
        console.log('getDiamondHandType: ', error);
        throw error;
    }
};

export const checkApprove = async (busdContract: Contract, poolContractAddr: string, address: string) => {
    try {
        const allowance = await busdContract.allowance(address, poolContractAddr);
        const userAlowance = new BigNumber(allowance.toString()).div(10 ** 18).toNumber();
        return userAlowance;
    } catch (error) {
        console.log('error: ', error);
        throw error;
    }
};

export const onRequestApproveToken = async (busdContract: Contract, poolContractAddr: string) => {
    try {
        const tx = await busdContract.approve(poolContractAddr, ethers.constants.MaxUint256);
        return tx;
    } catch (error) {
        console.log('onRequestApproveToken', error);
        throw error;
    }
};

export const onRequestBuy = async (poolContract: Contract, amount: number, listNftsLocked?: any) => {
    try {
        const tx = await poolContract.buyTokens(listNftsLocked, ethers.utils.parseEther(amount.toString()));
        return tx;
    } catch (error) {
        console.log('On Request Buy', error);
        throw error;
    }
};

export const onRequestBuyDiamond = async (poolContract: Contract, amount: number, diamondType?: any) => {
    try {
        const tx = await poolContract.buyTokens(diamondType, ethers.utils.parseEther(amount.toString()));
        return tx;
    } catch (error) {
        console.log('On Request Buy Diamond', error);
        throw error;
    }
};

export const onRequestRelease = async (poolContract: Contract) => {
    try {
        const tx = await poolContract.release();

        return tx;
    } catch (error) {
        console.log('onRequestRelease: ', error);
        throw error;
    }
};

export const checkAmount = async (busdContract: Contract, address: string) => {
    try {
        const result = await busdContract.balanceOf(address);

        const balance = new BigNumber(result.toString()).div(10 ** 18).toString();

        return balance;
    } catch (error) {
        console.log('checkAmount: ', error);
        throw error;
    }
};

export const getSolanaAddress = async (userAddress?: any, poolContract?: any) => {
    try {
        let solanaAddress = await poolContract.userCrossChainAddress(userAddress);
        return solanaAddress;
    } catch (error) {
        console.log('getSolanaAddress: ', error);
        throw error;
    }
};

export const apiSetSolanaAddress = async (poolContract?: any, solanaAddress?: any) => {
    try {
        const tx = await poolContract.setUserMultiChainAddress(solanaAddress);
        return tx;
    } catch (error) {
        console.log('apiSetSolanaAddress: ', error);
        throw error;
    }
};

export const getMAxAllowcation = async (poolContract: Contract, address: string) => {
    try {
        const individualCap = await poolContract.getMAxAllowcation(address);
        const cap = new BigNumber(individualCap.toString()).div(10 ** 18).toNumber();
        return cap;
    } catch (error) {
        console.log('getCap: ', error);
        throw error;
    }
};

export const getCap = async (poolContract: Contract, address: string) => {
    try {
        const individualCap = await poolContract.getCap(address);
        const cap = new BigNumber(individualCap.toString()).div(10 ** 18).toNumber();
        return cap;
    } catch (error) {
        console.log('getCap: ', error);
        throw error;
    }
};

export const getCurrentAllocation = async (listNftsLocked?: any, userAddress?: any, poolContract?: any) => {
    try {
        let currentAllocation = await poolContract.getCurrentAllocation(listNftsLocked, userAddress);
        return new BigNumber(currentAllocation.toString()).div(10 ** 18).toNumber();
    } catch (error) {
        console.log('currentAllocation: ', error);
        throw error;
    }
};

export const getCurrentAllocationDiamond = async (diamondType?: any, userAddress?: any, poolContract?: any) => {
    try {
        let currentAllocation = await poolContract.getCurrentAllocation(userAddress, diamondType);
        return new BigNumber(currentAllocation.toString()).div(10 ** 18).toNumber();
    } catch (error) {
        console.log('getCurrentAllocationDiamond: ', error);
        throw error;
    }
};

export const getMaxAllocation = async (listNftsLocked: any, userAddress: any, poolContract?: any) => {
    try {
        const maxAllocation = await poolContract.getMaxAllocation(userAddress, listNftsLocked);
        return new BigNumber(maxAllocation.toString()).div(10 ** 18).toNumber();
    } catch (error) {
        console.log('getMaxAllocation: ', error);
        throw error;
    }
};
export const getMaxAllocationDiamond = async (diamondType: any, userAddress: any, poolContract?: any) => {
    try {
        const maxAllocation = await poolContract.getMaxAllocation(userAddress, diamondType);
        return new BigNumber(maxAllocation.toString()).div(10 ** 18).toNumber();
    } catch (error) {
        console.log('getMaxAllocationDiamond: ', error);
        throw error;
    }
};
export const apiGetCurrentPool = async (networkFilter?: null | string) => {
    let apiURL = `${ENVS.REACT_APP_BASE_API}pool-approved/?filter[listing_status.in]=2&filter[pool_type]=1`;

    if (networkFilter) {
        apiURL += `&filter[network.in]=${networkFilter}`;
    }

    const parameters = {
        method: 'GET',
    };
    return fetch(apiURL, parameters)
        .then((response) => {
            return response.json();
        })
        .then((json) => {
            return json;
        });
};

export const apiGetPoolApprovedByType = async (poolType: any, status: any) => {
    const apiURL = `${ENVS.REACT_APP_BASE_API}pool-approved/?filter[pool_type]=${poolType}&filter[listing_status]=${status}`;
    const parameters = {
        method: 'GET',
    };
    return fetch(apiURL, parameters)
        .then((response) => {
            return response.json();
        })
        .then((json) => {
            return json;
        });
};

export const getPoolIdoJoined = async (
    poolContractAddr: string,
    address: any,
    isDiamondHand: any,
    library: Web3Provider | undefined,
    account: string | null | undefined,
) => {
    if (!account || !library) {
        throw new Error('Provider or Account not found');
    }
    let contractABI: any = contractIDOPoolABI;
    if (isDiamondHand) {
        contractABI = contractIDODiamondPoolABI;
    }
    const contract = getContract(poolContractAddr, contractABI, library, account);
    try {
        const accountInfo = await contract.getAccountInfo(address);
        const contributions = new BigNumber(accountInfo[0].toString()).div(10 ** 18).toNumber();
        const userTokenBalance = new BigNumber(accountInfo[1].toString()).div(10 ** 18).toNumber();
        const userVestedBalance = new BigNumber(accountInfo[2].toString()).div(10 ** 18).toNumber();
        const lasTimeVesting = accountInfo[3].toNumber();
        return { contributions, userTokenBalance, userVestedBalance, lasTimeVesting };
    } catch (error) {
        console.log('getPoolIdoJoined: ', error);
        throw error;
    }
};
